
import { Options } from "vue-class-component";
import ComponentConfigMixins from "../ComponentConfigMixins";

@Options({
    name: "flowable-common-form-components-file-upload-config",
})
export default class FileUploadConfig extends ComponentConfigMixins {}
